import { Component, OnInit, inject } from '@angular/core';
import {DataService} from "../services/data.service";
import {ToastrService} from "ngx-toastr";
import {FormsModule} from "@angular/forms";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-settings',
    imports: [FormsModule, NgIf],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3><i class="fa-solid fa-user me-2"></i>Benutzerprofil</h3>
                </div>

                <form autocomplete="off" *ngIf="user">
                    <div class="row">
                        <div class="col">
                            <label>Vorname</label>
                            <p>{{ user.firstname }}</p>
                        </div>
                        <div class="col">
                            <label>Nachname</label>
                            <p>{{ user.lastname }}</p>
                        </div>
                        <div class="col">
                            <label>E-Mail</label>
                            <p>
                                <a [href]="'mailto:' + user.email">{{ user.email }}</a>
                            </p>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label class="form-label"><i class="fa fa-key"></i> Passwort</label>
                        <input type="password" class="form-control" name="newPass" [(ngModel)]="newPass">
                    </div>
                    <div class="mb-3">
                        <label class="form-label"><i class="fa fa-key"></i> Passwort wiederholen</label>
                        <input type="password" class="form-control" name="newPassConfirm" [(ngModel)]="newPassConfirm">
                    </div>

                    <button type="button" class="btn btn-primary" [disabled]="newPass != newPassConfirm" (click)="updateUser()">
                        Speichern
                    </button>
                </form>
            </div>
        </div>
    `
})
export class SettingsComponent implements OnInit {

    private dataService = inject(DataService);
    private toastrService = inject(ToastrService);

    newPass: string|null = '';
    newPassConfirm: string|null = '';
    user: any;
    id_desk: any;

    ngOnInit(): void {
        this.newPass = null;
        this.newPassConfirm = null;

        this.dataService.request('User/get').subscribe(response => {
            this.user = response.user;
            this.id_desk = response.user.id_desk === null ? "" : response.user.id_desk;
        });
    }

    updateUser(): void {
        this.dataService.request('User/update', {
            password: this.newPass,
            id_desk: this.id_desk,
        }).subscribe(() => {
            this.toastrService.success('Daten wurden gespeichert');
            this.newPass = null;
            this.newPassConfirm = null;
        });
    }

}
